import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-slider__pagination--title pointer flex al-center ov-hidden rel",
  "data-scale-type": "1"
}


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
  },
  index: {
    type: Number,
  },
  isTransitioningStepTwo: {
    type: Boolean,
  }
},
  setup(__props) {

const props = __props

// PROPS


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "main-slider__pagination--title-wrapper ev-none",
      style: _normalizeStyle(__props.isTransitioningStepTwo ? { 'animation-delay': 0.12 * __props.index + 's' } : { 'animation-delay': 0.0 + 's' })
    }, [
      _createElementVNode("h2", {
        class: "regular t-design uppercase wc-lg luxury ev-none",
        style: _normalizeStyle(__props.isTransitioningStepTwo ? { 'animation-delay': 0.12 * __props.index + 's' } : { 'animation-delay': 0.0 + 's' })
      }, _toDisplayString(__props.title), 5)
    ], 4)
  ]))
}
}

})